// @flow

import React, { useCallback } from "react";
import * as R from "ramda";

import { FileSelect as StyledFileSelect } from "./styles";
import SelectFiles from "src/components/file/SelectMultiple";

type Props = {
  files: Array<string>,
  handleFiles: Function
};

const FileSelect = ({ files, handleFiles }: Props) => {
  const handleSelect = useCallback(
    (newFile: string) => {
      if (R.includes(newFile, files)) {
        handleFiles(files.filter(file => file !== newFile));
      } else {
        handleFiles([...files, newFile]);
      }
    },
    [handleFiles, files]
  );

  return (
    <StyledFileSelect>
      <SelectFiles
        placeholder="Select files"
        value={files}
        handleSelect={handleSelect}
      />
    </StyledFileSelect>
  );
};

export default FileSelect;
